import React, { Fragment, useEffect, useMemo } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { useBenefitsModal } from '../../controllers/use-benefits-modal/index.tsx';
import { benefitsModalEntryPoint } from './entrypoint.tsx';

type Nav4BenefitsModalTriggerProps = {
	testOverride?: boolean;
};

/**
 * This component is not indented to be executed on the server. Call-site
 * should use {!__SERVER__ && <Nav4BenefitsModalTrigger />}.
 */
export const Nav4BenefitsModalTrigger = componentWithFG(
	'navx-481-jira-benefits-modal',
	Nav4BenefitsModalTriggerActual,
	Fragment,
);

function Nav4BenefitsModalTriggerActual({ testOverride }: Nav4BenefitsModalTriggerProps) {
	const { shouldShowModal, setModalShown } = useBenefitsModal();
	const entryPointParams = useMemo(() => ({ onShow: () => setModalShown(true) }), [setModalShown]);
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		benefitsModalEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		const shouldShow = shouldShowModal();
		// Determine if the modal should show
		if (testOverride || shouldShow) {
			entryPointActions.load();
		} else if (testOverride && !shouldShow) {
			// Only unload during testing
			entryPointActions.unload();
		}
	}, [testOverride, shouldShowModal, entryPointActions]);

	return (
		<JiraEntryPointContainer
			// Required props for error JSErrorBoundary.
			id="nav4-onboarding-benefits-modal-ep-container"
			entryPointReferenceSubject={entryPointReferenceSubject}
			// Props for the root component.
			runtimeProps={{}}
			{...entryPointParams}
		/>
	);
}
